export default "__VITE_ASSET__Ka5VMBGY__"